// extracted by mini-css-extract-plugin
module.exports = {"inBlock":"Spinner_inBlock__1FmNo","inBackdrop":"Spinner_inBackdrop__3sf4u"};